import { authorize, init } from 'actions/ExtensionAction'
import { User } from 'models/User'
import { createContext, ReactNode, useContext, useState } from 'react'
import { useOneShot } from 'hooks/useOneShot'

export type ExtensionState = {
    user: User,
    isDark: boolean
    isLogin: boolean
}

const ExtensionContext = createContext<ExtensionState | undefined>(undefined)

export const ExtensionContextProvider: React.FC<{ children: ReactNode }> = ({children}) => {
    const [state, setState] = useState<ExtensionState | undefined>(undefined)

    useOneShot(() => {
        (async () => {
            try {
                const state = await fetchExtensionState()
                setState(state)
            } catch (e: unknown) {
                console.log(e)
            }
        })()
    })

    if (!state) {
        return null;
    }

    return (
        <ExtensionContext.Provider value={state}>
            {children}
        </ExtensionContext.Provider>
    )
}

export const useExtensionContext: () => ExtensionState = () => {
    const value = useContext(ExtensionContext)
    if (!value) {
        throw new Error('Call it in ExtensionContextProvider.')
    }
    return value
}

const fetchExtensionState: () => Promise<ExtensionState> = async () => {
    const [initialData, authData] = await Promise.all([
        init(), 
        authorize()
    ])

    return {
        user: User.of({ id: initialData.movie.user.id }),
        isDark: initialData.theme === 'dark',
        isLogin: authData.error == null
    }
}
